<template>
  <div class="hp-manager-page-list">
    <filter-form :filter="filter" @handleSubmit="handleSubmit"></filter-form>
    <standard-table
      ref="datas"
      size="default"
      :bordered="true"
      :columns="columns"
      :indentSize="15"
      :dataSource="datas"
      :pagination="pagination"
      :loading="loading"
      @tableChange="tableChange"
    >
      <template slot="selfactions" slot-scope="rowKey">
        <span>
          <a href="javascript:;" @click="download(rowKey.data)" :disabled="rowKey.data.exportResult!=2">下载</a>
          <a-divider type="vertical"/>
          <a href="javascript:;" @click="deldata(rowKey.data)" :disabled="rowKey.data.exportResult==1">删除</a>
        </span>
      </template>
    </standard-table>
  </div>
</template>

<script>
import { api } from "@/common";
import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import { watch } from "fs";
import config from "@/config";
export default {
  mixins: [account, dateFormat],
  components: {},
  data() {
    return {
      filter: [
        {
          type: "select",
          key: "taskType",
          name: "任务类型",
          options: [
            { name: "导出经销商", val: 1 },
          ]
        },
        {
          type: "select",
          key: "exportResult",
          name: "状态",
          options: [
            { name: "没有执行", val: 0 },
            { name: "执行中", val: 1 },
            { name: "执行成功", val: 2 },
            { name: "执行失败", val: 3 }
          ]
        },
        {
          type: "dateFilter",
          key: "rangeDate",
          name: "创建日期"
        }
      ],
      columns: [
        {
          title: "操作",
          dataIndex: "action",
          width: "10%",
          scopedSlots: { customRender: "action" }
        },
        {
          title: "任务类型",
          width: "20%",
          dataIndex: "taskType",
          sorter: true,
          customRender: (text, row, index) => {
            return row.taskTypeDes;
          }
        },
        {
          title: " 创建时间",
          dataIndex: "creationTime",
          width: "20%",
          sorter: true,
          customRender: (text, row, index) => {
            return this.formatDate(row.creationTime, "YYYY-MM-DD HH:mm:ss");
          }
        },
        {
          title: " 完成时间",
          dataIndex: "lastModificationTime",
          width: "30%",
          sorter: true,
          customRender: (text, row, index) => {
            return row.lastModificationTime != null
              ? this.formatDate(row.lastModificationTime, "YYYY-MM-DD HH:mm:ss")
              : "";
          }
        },
        {
          title: " 状态",
          dataIndex: "exportResult",
          width: "20%",
          sorter: true,
          customRender: (text, row, index) => {
            return row.exportResultDes;
          }
        }
      ],
      datas: [],
      filterdata: JSON.parse(JSON.stringify(config.pageFilter)),
      pagination: JSON.parse(JSON.stringify(config.page)),
      params: {},
      maxResultCount: config.page.pageSize,
      loading: false,
      pageSizeOptions: config.page.pageSizeOptions,
      modalWidth: "500px"
    };
  },
  async mounted() {
    this.getDatas(this.filterdata);
  },
  methods: {
        handleSubmit(p) {
      this.pagination.current=0;  
      this.filterdata.exportResult = p.values.exportResult;
      this.filterdata.taskType = p.values.taskType;
      this.filterdata.createTimeStart =
        p.values.rangeDate[0] != null ? p.values.rangeDate[0].valueOf() : null;
      this.filterdata.createTimeEnd =
        p.values.rangeDate[1] != null ? p.values.rangeDate[1].valueOf() : null;
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.getDatas(this.filterdata);
    },
    refreshCurrent() {this.pagination.current=0;
      this.filterdata.skipCount = 0;
      this.filterdata.maxResultCount = this.maxResultCount;
      this.getDatas(this.filterdata);
    },
    tableChange(table) {
      if (table.page) {
        this.pagination.current = table.page.current;
        this.pagination.pageSize = table.page.pageSize;
        this.maxResultCount = table.page.pageSize;
        this.filterdata.skipCount =
          table.page.current == 1
            ? 0
            : (table.page.current - 1) * this.maxResultCount;
        this.filterdata.maxResultCount = table.page.pageSize;
      }
      if (table.sorter.field) {
        this.filterdata.sorting =
          table.sorter.field +
          " " +
          (table.sorter.order == "ascend" ? "asc" : "desc");
      }
      this.getDatas(this.filterdata);
    },
    //删除数据
    async deldata(row) {
      let that = this;
      new Promise(async (resolve, reject) => {
        this.$confirm({
          title: "警告",
          content: "确定要删除此数据?",
          okText: "删除",
          centered: "centered",
          okType: "danger",
          cancelText: "取消",
          onOk() {
            that.delHandle(row);
          },
          onCancel() {
            console.log("Cancel");
          }
        });
      });
    },
    async delHandle(row) {
      let msgRet = await api.DeleteExportTask({ id: row.id });
      if (msgRet) {
        this.$message.success("删除成功");
        if (
          this.pagination.total - 1 <=
          this.pagination.pageSize * (this.pagination.current - 1)
        ) {
          this.filterdata.skipCount =
            this.pagination.current == 1
              ? 0
              : (this.pagination.current - 2) * this.maxResultCount;
          this.pagination.current =
            this.pagination.current == 1 ? 1 : this.pagination.current - 1;
        }
        this.getDatas(this.filterdata);
      }
    },
    async download(row) {
      await api.ExportDownload({fileId:row.taskGuid,fileName:row.fileName});
    },
    async getDatas(options) {
      this.loading = true;
      let data = await api.GetExportTaskList(options);
      this.datas = data.items;
      if (data) {
        this.pagination.total = data.totalCount;
        this.pagination.showTotal = bbb => `共有 ${data.totalCount} 条`;
        this.pagination.pageSize = this.maxResultCount;
      }
      this.loading = false;
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/router/Reports/ExportTask/List.vue